<template>

    <!-- Page Sidebar Ends-->
    <div class="page-body">
        <PageTitle title="Employees" />
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-header">
                            <button class="btn btn-secondary" type="button" data-bs-toggle="modal"
                                data-original-title="test" data-bs-target="#employeeAdd">Add Employee</button>
                               &nbsp;&nbsp;
                                <button class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#importModal">
                                  <i class="icofont icofont-cloud-download"></i> Import CSV
                                </button>
                               
                        </div>
                        <div class="card-body badge-spacing">
                            <div class="table-responsive custom-scrollbar">
                                <table class="table display" id="usersdatatble">
                                    <thead>
                                        <tr>
                                            <th>Sr.No.</th>
                                            <th>Code</th>
                                            <th>Name</th>
                                            <th>Contact</th>
                                            <th>Department</th>
                                            <th>Password</th>
                                            <th>Role</th>
                                            <th>HOD</th>
                                            <th>HOS</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr  v-for="(item ,index)  in employees" :key="item.id" >
                                            <td>{{index+1}}</td>
                                            <td>{{item.empcode}}</td>
                                            <td>{{item.empname}}</td>
                                            <td>{{item.contact}}</td>
                                            <td>{{item.dept_name}}</td>
                                            <td>{{item.emppwd}}</td>
                                            <td>
                                                <span v-if="item.emprole==1">ADMIN</span>
                                                <span v-else-if="item.emprole==5">GM</span>
                                                <span v-else-if="item.emprole==2">HOD</span>
                                                <span v-else-if="item.emprole==3">Employee</span>
                                                <span v-else-if="item.emprole==4">Security Admin</span>
                                                <span v-else-if="item.emprole==6">HOS</span>
                                                <span v-else-if="item.emprole==7">Kitchen</span>
                                            </td>
                                            <td>{{item.hod_name}}</td>
                                            <td>{{item.hos_name}}</td>
                                            <td>{{(item.empstatus==1)?'Active':'De-Active'}}</td>
                                            <td>
                                                <ul class="action">
                                                    <li class="edit" @click="edit_employee(item)"><i class="icon-pencil-alt"></i></li>
                                                    <li class="delete" @click="remove_employee(item.id)"><i class="icon-trash"></i></li>
                                                </ul>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- footer   start-->
 <div class="modal fade" id="importModal" tabindex="-1" aria-labelledby="importModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <form @submit.prevent="uploadCsv">
            <div class="modal-header">
              <h5 class="modal-title" id="importModalLabel">Upload Employee CSV</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div class="modal-body">
              <input type="file" class="form-control" @change="handleFileChange" accept=".csv" required />
              <div v-if="status && status.message" :class="['mt-3', 'alert', status.success ? 'alert-success' : 'alert-danger']">
                {{ status.message }}
              </div>
              <div v-if="loading" class="text-info mt-2">Uploading...</div>
            </div>

            <div class="modal-footer">
              <button type="submit" class="btn btn-success" :disabled="loading || !file">Upload & Import</button>
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    
      <div class="modal fade" id="employeeAdd" tabindex="-1" role="dialog" aria-labelledby="employeeAdd"
        aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Add Employee</h4>
                    <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="modal-toggle-wrapper">
                        <div class="col-sm-12">
                            <div class="row g-3">
                                <div class="col-md-6 position-relative">
                                    <label class="form-label">Employee Code</label>
                                    <input class="form-control" type="text" v-model="emp.empcode"
                                        placeholder="Type Here..." required="">
                                </div>
                                <div class="col-md-6 position-relative">
                                    <label class="form-label">Employee Name</label>
                                    <input class="form-control" type="text" v-model="emp.empname"
                                        placeholder="Type Here..." required="">
                                </div>
                                <div class="col-md-6 position-relative">
                                    <label class="form-label">Employee Contact Number</label>
                                    <input class="form-control" type="text" @input="acceptNumberEmp"
                                        v-model="emp.contact" placeholder="Type Here..." required="">
                                </div>
                                <div class="col-md-6 position-relative">
                                    <label class="form-label">Employee Department</label>
                                    <select class="form-select" required="" v-model="emp.empdept">
                                        <option selected="" disabled="" value="">Choose...</option>
                                        <option v-for="(item, index)  in departments" :key="item.id" :value="item.id">{{
                                            item.deptname }}</option>
                                    </select>
                                </div>
                                <div class="col-md-6 position-relative">
                                    <label class="form-label">Employee Password</label>
                                    <input class="form-control" type="text" v-model="emp.emppwd"
                                        placeholder="Type Here..." required="">
                                </div>
                                <div class="col-md-6 position-relative">
                                    <label class="form-label">Employee Role</label>
                                    <select class="form-select" required="" v-model="emp.emprole">
                                        <option selected="" disabled="" value="">Choose...</option>
                                        <option value="1">Admin</option>
                                        <option value="5">GM</option>
                                        <option value="2">HOD</option>
                                        <option value="6">HOS</option>
                                        <option value="3">Employee</option>
                                        <option value="4">Security Admin</option>
                                        <option value="7">Kitchen</option>
                                    </select>
                                </div>
                                <div class="col-md-6 position-relative">
                                    <label class="form-label">Employee Status</label>
                                    <select class="form-select" required="" v-model="emp.empstatus">
                                        <option selected="" disabled="" value="">Choose...</option>
                                        <option value="1">Active</option>
                                        <option value="2">De-Active</option>
                                    </select>
                                </div>
                                <div class="col-md-6 position-relative">
                                    <label class="form-label">Employee HOS</label>
                                   <select class="form-select" required v-model="emp.hos" id="emp_hos">
                                          <!--<option disabled value="">Choose...</option>-->
                                          <option 
                                            v-for="item in employees" 
                                            :key="item.id" 
                                            :value="item.empcode" 
                                          >
                                            {{ item.empname }}
                                          </option>
                                        </select>
                                </div>
                                <div class="col-md-6 position-relative">
                                    <label class="form-label">Employee HOD</label>
                                    <select class="form-select" required v-model="emp.hod"  id="emp_hod">
                                          <!--<option disabled value="">Choose...</option>-->
                                          <option 
                                            v-for="item in employees" 
                                            :key="item.id" 
                                            :value="item.empcode" 
                                          >
                                            {{ item.empname }}
                                          </option>
                                        </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="col-12">
                        <button class="btn btn-primary" @click="save_emp">Save Data</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <!--<ModalsPart v-if="!['login'].includes($route.name)"  @getEmpData="updateEmpData" :edit_emp_row="editEmployee"/>-->
</template>

<script>
// @ is an alias to /src 
import PageTitle from '@/components/PageTitle.vue';
import ModalsPart from '@/components/Modals.vue';
// import axios from 'axios';
import axios from "@/plugins/axios";
const config = {
            headers: {
               "Content-Type": "application/x-www-form-urlencoded"
            },
            responseType: 'json'
         };
export default {
    name: 'Users', 
    components: {
        PageTitle, ModalsPart
    }, mounted() {
        this.getBasics();

    }, data() {
        return {
          employees: [],
          editEmployee:[],
          departments:[],
          departments:[],
           emp: { "empname": '', "empcode": '', "empdept": '', "emppwd": '', "emprole": '', "empstatus": '', 'contact': '', 'hod': '', 'hos': '' },
           file: null,
              loading: false,
              status: {
                message: '',
                success: false,
              },
        }
    },
    methods: { 
        
            acceptNumberEmp() {
                var x = this.emp.contact.replace(/\D/g, '').match(/(\d{0,10})/);
                this.emp.contact = x[1];

            },
         handleFileChange(event) {
          this.file = event.target.files[0];
          this.status = { message: '', success: false };
        },
    async uploadCsv() {
        var self=this;
        
          if (!this.file) return;
    
          this.loading = true;
          this.status = { message: '', success: false };
    
          const formData = new FormData();
          formData.append('csv_file', this.file);
    
          try {
            const response = await axios.post('/import-csv', formData, {
              headers: { 'Content-Type': 'multipart/form-data' },
            });
    
            this.status = {
              message: response.data.message || 'CSV imported successfully!',
              success: true,
            };
            this.file = null;
            event.target.reset?.();
            
            if(response.data.success && response.data.success==1){
                 self.employees = response.data.employees; 
            }
            
            
          } catch (error) {
            this.status = {
              message: error.response?.data?.message || 'Upload failed. Please try again.',
              success: false,
            };
          } finally {
            this.loading = false;
          }
        }, 
  
  
        updateEmpData(value) {
            this.destroyTable();
            this.employees = value;
            this.refreshTable()
            
        },
         destroyTable(){
                if ($.fn.dataTable.isDataTable('#usersdatatble')) {
                                    $('#usersdatatble').DataTable().destroy();
                                } 
            },
    refreshTable(){
        var self=this;
         self.$nextTick(() => { 
                    $("#usersdatatble").DataTable({
                        dom: 'Bfrtip',
                        // buttons: ['excel', 'pdf',{
                        //                         text: 'Filter',
                        //                         action: function (e, dt, node, config) {
                        //                           self.filterlist();
                        //                         }
                        //                       }],
                        buttons: ['excel', 'pdf'],
                        "paging": true,
                        "ordering": true,
                        "autoWidth": false,
                       "aaSorting": [],
                         order: [], 
                    });
                    
                    
                    
                    
         });
    },
        getBasics() {
            var self = this;
            axios.post('getEmployees').then(function (response) {
                self.destroyTable();
                self.employees = response.data.employees; 
                self.departments = response.data.departments;  
                // window.scrollTo(0, 0);
                self.refreshTable();
                 self.$nextTick(() => {   
                 
                      
                      $("#emp_hos").select2({
                            width: '100%',
                            placeholder: "Search HOS Here...",
                            dropdownParent: $('#employeeAdd'),
                            "language": {
                                "noResults": function () {
                                    return "No Results Found";
                                }
                            },
                            escapeMarkup: function (markup) {
                                return markup;
                            }
                        }).on('change', function (event) {

                            const selectedId = $(this).val(); // gets the selected ID/value
                           
                            self.emp.hos = selectedId; // store the ID in the visitor object
                           


                        });

                   $("#emp_hod").select2({
                            width: '100%',
                            placeholder: "Search HOD Here...",
                             dropdownParent: $('#employeeAdd'),
                            "language": {
                                "noResults": function () {
                                    return "No Results Found";
                                }
                            },
                            escapeMarkup: function (markup) {
                                return markup;
                            }
                        }).on('change', function (event) {

                            const selectedId = $(this).val(); // gets the selected ID/value
                           
                            self.emp.hod = selectedId; // store the ID in the visitor object
                           


                        });
            
         });
             }).then(() => {
                 
             });
        },
        remove_employee(id) {
            var self = this;
            axios.post('removeEmployee', {emp_id:id}).then(function (response) {
                self.destroyTable();
                self.employees = response.data.employees; 
                // window.scrollTo(0, 0);
             }).then(() => {
                 self.refreshTable();
            });
        },
        edit_employee(item)
        {
            var self = this;
            self.emp = item; 
            $("#employeeAdd").modal("toggle");
            
            $("#emp_hod option").filter(function() {
              return $(this).text() === item.hod_name;
            }).prop('selected', true);
            $('#emp_hod').trigger('change');
            
            
            $("#emp_hos option").filter(function() {
              return $(this).text() === item.hos_name;
            }).prop('selected', true);
            $('#emp_hos').trigger('change');
           
            
        },
        
        //21.07.2025
           save_emp() {
                var self = this;

                if (!self.emp.empname) {

                    self.$swal("Enter Employee Name");

                } else if (!self.emp.empcode) {
                    self.$swal("Enter Employee Code");

                } else if (!self.emp.emppwd) {
                    self.$swal("Enter Employee Password");
                } else if (!self.emp.contact) {
                    self.$swal("Enter Employee Contact");
                } else {


                    const formData = new FormData();
                    formData.append('empname', self.emp.empname);
                    formData.append('empcode', self.emp.empcode);
                    formData.append('empdept', self.emp.empdept);
                    formData.append('emppwd', self.emp.emppwd);
                    formData.append('emprole', self.emp.emprole);
                    formData.append('empstatus', self.emp.empstatus);
                    formData.append('contact', self.emp.contact);
                    formData.append('hos', self.emp.hos);
                    formData.append('hod', self.emp.hod);
                    
                    
                    
                    formData.append('id', self.emp.id ?? 0);
                    axios.post('add_employee', formData)
                        .then(response => {
                            var msg = response.data.msg;
                            var isSuccess = response.data.status;
                            self.$swal(msg);
                            if (isSuccess == 1) {
                                self.employees = response.data.employees;
                                self.emp = { "empname": '', "empcode": '', "empdept": '', "emppwd": '', "emprole": '', "empstatus": '', 'contact': '' },
                                    $("#employeeAdd").modal("toggle");
                                
                            }
                        })
                        .catch(error => {
                            console.log('Error on Authentication: ' + error);
                        });
                }
            },
       
    }
}
</script>
